import React, { useState } from 'react';
import gmaxLogoContact from '../assets/gmax-logo-contact.jpeg';

const Contact = () => {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: '',
  });
  
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(false);
    
    try {
      // Formspree endpoint - replace with your form ID
      const response = await fetch('https://formspree.io/f/mdkzobdn', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formState)
      });
      
      if (response.ok) {
        setSubmitted(true);
        setFormState({
          name: '',
          email: '',
          phone: '',
          company: '',
          message: '',
        });
      } else {
        setError(true);
      }
    } catch (err) {
      setError(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gmax-dark-blue text-white py-16">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Entre em Contato</h1>
            <p className="text-xl max-w-3xl mx-auto">
              Estamos prontos para atender às necessidades da sua empresa. Preencha o formulário abaixo e entraremos em contato o mais breve possível.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row gap-12">
            <div className="lg:w-1/2">
              <h2 className="section-title mb-6">Envie sua mensagem</h2>
              
              {submitted ? (
                <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-6">
                  <p className="font-bold">Mensagem enviada com sucesso!</p>
                  <p>Agradecemos seu contato. Nossa equipe retornará em breve.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-6">
                  {error && (
                    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-6">
                      <p className="font-bold">Erro ao enviar mensagem</p>
                      <p>Por favor, tente novamente ou entre em contato pelo telefone.</p>
                    </div>
                  )}
                  
                  <div>
                    <label htmlFor="name" className="block text-gray-700 font-medium mb-2">Nome Completo *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formState.name}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gmax-blue"
                      required
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="email" className="block text-gray-700 font-medium mb-2">E-mail *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formState.email}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gmax-blue"
                      required
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="phone" className="block text-gray-700 font-medium mb-2">Telefone</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formState.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gmax-blue"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="company" className="block text-gray-700 font-medium mb-2">Empresa</label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formState.company}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gmax-blue"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="message" className="block text-gray-700 font-medium mb-2">Mensagem *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formState.message}
                      onChange={handleChange}
                      rows="5"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gmax-blue"
                      required
                    ></textarea>
                  </div>
                  
                  <div>
                    <button
                      type="submit"
                      className="btn-primary w-full"
                      disabled={submitting}
                    >
                      {submitting ? 'Enviando...' : 'Enviar Mensagem'}
                    </button>
                  </div>
                </form>
              )}
            </div>
            
            <div className="lg:w-1/2">
              <h2 className="section-title mb-6">Informações de Contato</h2>
              
              <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="flex justify-center mb-6">
                  <img 
                    src={gmaxLogoContact} 
                    alt="GMAX Soluções" 
                    className="h-24"
                  />
                </div>
                
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="text-gmax-blue text-xl mr-4">
                      <i className="fas fa-envelope"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gmax-dark-blue">E-mail</h3>
                      <p className="text-gray-600">comercial@gmaxs.com.br</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="text-gmax-blue text-xl mr-4">
                      <i className="fas fa-phone"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gmax-dark-blue">Telefone</h3>
                      <p className="text-gray-600">(43) 99195-2859</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="text-gmax-blue text-xl mr-4">
                      <i className="fas fa-clock"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gmax-dark-blue">Horário de Atendimento</h3>
                      <p className="text-gray-600">Segunda a Sexta: 8h às 18h</p>
                    </div>
                  </div>
                </div>
                
                <div className="mt-8">
                  <h3 className="font-bold text-gmax-dark-blue mb-4">Siga-nos nas Redes Sociais</h3>
                  <div className="flex space-x-4">
                    <a href="#" className="text-gmax-blue hover:text-gmax-dark-blue text-2xl">
                      <i className="fab fa-linkedin"></i>
                    </a>
                    <a href="#" className="text-gmax-blue hover:text-gmax-dark-blue text-2xl">
                      <i className="fab fa-facebook"></i>
                    </a>
                    <a href="#" className="text-gmax-blue hover:text-gmax-dark-blue text-2xl">
                      <i className="fab fa-instagram"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
